module.exports = __webpack_public_path__ + "media/images/arrow-left-white-7744d37f610c872cfbeef42d338517b8.png";